import {Avatar, Body1, Alert, Box, Button, Chip, Heading5, styled, Subtitle2, CloseIcon, CollectionsOutlinedIcon} from '../../../ui-library';


export const ModalBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    position: absolute;
    width: 740px;
    height: fit-content;
    max-height: 600px;
    left: calc(50% - 740px/2);
    top: calc(50% - 632px/2);
    background: #FFFFFF;
    border-radius: 10px;
`;

export const ModalTitle = styled(Heading5)`
    ${({ theme }) => theme.typography.h5};
    margin-top: 48px;
    margin-bottom: 24px;
`;

export const LabelTitle = styled(Subtitle2)`
    color: ${({ theme }) => theme.palette.grey[700]};
    margin-top: 24px;
    margin-bottom: 0px;
`;

export const ProjectName = styled(Body1)`
    color: ${({ theme }) => theme.palette.grey[700]};
    margin-top: 7px;
`;

export const StartBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    position: absolute;
    bottom: 28px;
    color: white;
    font-size: 16px;
    line-height: 26px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    background: ${({ theme }) => theme.palette.primary.main};
    :hover {
      background-color: ${({ theme }) => theme.palette.primary.dark};
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    }
    :focus {
        background:(${({ theme }) => theme.palette.primary.main}, ${({ theme }) => theme.palette.primary.main});
    }
`;

export const ButtonsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
`;

export const EmailChip = styled(Chip)`
    color: ${({ theme }) => theme.palette.grey[800]};
    background-color: ${({ theme }) => theme.palette.primary.light};
    & .MuiChip-label{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.16px;
        color: ${({ theme }) => theme.palette.grey[900]};
  }
`;

export const ClassChip = styled(Chip)`
    color: ${({ theme }) => theme.palette.grey[900]};
    background-color: ${({ theme }) => theme.palette.grey[200]};
    & .MuiChip-label{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.16px;
        color: ${({ theme }) => theme.palette.grey[900]};
  }
`;

export const ChipAvatar = styled(Avatar)`
    background-color: ${({ theme }) => theme.palette.grey[300]};
`;

export const ChipsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    margin-top: 7px;
`;

export const AutoAlert = styled(Alert)`
    width: 100%;
    margin-top: 24px;
`;

export const ExitIcon = styled(CloseIcon)`
    position: absolute;
    right: 25px;
    top:25px;
    font-size: 24px;
    color: ${({ theme }) => theme.palette.grey[500]};
    cursor: pointer;
`;

export const ClassesBox = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap:8.67px;
    align-items: center;
    margin-top: 7px;
    margin-bottom: 98px;
    max-height: 200px;
    overflow-y: auto;
`;

export const ClassContainer = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    gap:8.67px;
`;

export const ImagesIcon = styled(CollectionsOutlinedIcon)`
    color : ${({ theme }) => theme.palette.grey['600']};
    font-size: 16px;
`;

export const NumOfImages = styled(Subtitle2)`
    color: ${({ theme }) => theme.palette.grey['800']};
    padding-right: 18.33px;
`;
